module.exports = __webpack_public_path__ + "img/building-icon-supply.6b8fe973.png";